import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import LinkDistributorModal from "../../components/modals/Distributor/linkDistributorModal";
import { distributorList } from "../../redux/actions/distributorActions";
import DistributorTableData from "./distributorTableData";
import DownArrow from "../../assets/filterArrowDown.svg";
import UpArrow from "../../assets/filterArrowUp.svg";
import ErrorPopup from "../../components/popups/ErrorPopup";
import LoadingSpinnerTable from "../../components/utilites/loader";
import NumberPagination from "../../components/Pagination/number-pagination";
import { useNavigate, useParams } from "react-router-dom";

const DistributorTable = ({
  search,
  linkShow,
  linkClose,
  is_subscribed,
  status,
  page_no,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const componentRef = useRef(null);
  const [page, setPage] = useState(page_no ? page_no : 1);
  const [distributorListData, setDistributorListData] = useState([]);
  const [openStatus, setOpenStatus] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (page_no) {
      setPage(page_no);
    }
  }, [page_no]);

  const distributorListFunc = () => {
    dispatch(
      distributorList(
        {
          search,
          status:
            status === "active" ? true : status === "inactive" ? false : null,
          page,
        },
        onSuccess,
        onError
      )
    );
  };

  useEffect(() => {
    setLoading(true);
    distributorListFunc();
  }, [search, status, page]);

  const onSuccess = (data) => {
    setLoading(false);
    setDistributorListData(data?.data?.data);
  };
  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onError = (err) => {
    setLoading(false);

    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  const handleClickOutside = (event) => {
    if (componentRef.current && !componentRef.current.contains(event.target)) {
      setOpenStatus(false);
    }
  };

  useEffect(() => {
    if (openStatus) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [openStatus]);

  const queryParams = [];
  if (search) queryParams.push(`search=${search}`);
  if (status) queryParams.push(`status=${status}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  return (
    <>
      <div>
        <div className="table-container text-nowrap">
          <table className="main-table" style={{ position: "relative" }}>
            <thead>
              <tr className="table-rows">
                <th className="table-heads " width={"2%"}>
                  #
                </th>
                <th className="table-heads " width={"6%"}>
                  Distributor ID
                </th>
                <th className="table-heads " width={"8%"}>
                  Firm Name
                </th>
                <th className="table-heads " width={"8%"}>
                  State
                </th>
                <th className="table-heads " width={"8%"}>
                  City
                </th>
                <th className="table-heads " width={"9%"}>
                  Phone Number
                </th>
                <th className="table-heads " width={"10%"}>
                  Email Address
                </th>
                <th className="table-heads " width={"7%"}>
                  Pending Orders
                </th>
                <th className="table-heads " width={"8%"}>
                  Given Orders
                </th>
                <th
                  ref={componentRef}
                  className="table-heads text-nowrap"
                  width={"8%"}
                >
                  <span
                    className={
                      openStatus
                        ? "Medium_Purple cursor_pointer"
                        : "cursor_pointer"
                    }
                    onClick={() => {
                      setOpenStatus(!openStatus);
                    }}
                  >
                    <span className={status ? "Medium_Purple fw_700" : ""}>
                      Status
                    </span>
                    {openStatus ? (
                      <img src={UpArrow} className="mb-1 mx-1" alt="v" />
                    ) : (
                      <img src={DownArrow} className=" mx-1" alt="v" />
                    )}
                  </span>
                  {openStatus ? (
                    <div className="position-relative">
                      <div className="position-absolute status-container d-flex gap-3 px-3">
                        <div className="d-flex align-items-center ">
                          <input
                            className="radio me-2"
                            type="radio"
                            id="active"
                            name="status"
                            value={"active"}
                            checked={status === "active"}
                            onClick={(e) => {
                              setOpenStatus(!openStatus);
                              navigate(
                                `/distributors/onboarded?page=1${
                                  search ? `&search=${search}` : ""
                                }&status=active`
                              );
                            }}
                          />
                          <label
                            htmlFor="active"
                            className={
                              status === "active"
                                ? "color_262c3d cursor_pointer"
                                : "color_747f9e cursor_pointer"
                            }
                          >
                            Active
                          </label>
                        </div>
                        <div className="d-flex align-items-center ">
                          <input
                            className="radio me-2"
                            type="radio"
                            id="inactive"
                            name="status"
                            value={"inactive"}
                            checked={status === "inactive"}
                            onClick={(e) => {
                              setOpenStatus(!openStatus);
                              navigate(
                                `/distributors/onboarded?page=1${
                                  search ? `&search=${search}` : ""
                                }&status=inactive`
                              );
                            }}
                          />
                          <label
                            htmlFor="inactive"
                            className={
                              status === "inactive"
                                ? "color_262c3d cursor_pointer"
                                : "color_747f9e cursor_pointer"
                            }
                          >
                            Inactive
                          </label>
                        </div>
                        <button
                          className="filter-btn px-2 py-0 my-2 fs_12"
                          style={{ height: "28px" }}
                          onClick={() => {
                            setOpenStatus(!openStatus);
                            navigate(
                              `/distributors/onboarded?page=1${
                                search ? `&search=${search}` : ""
                              }`
                            );
                          }}
                        >
                          CLEAR
                        </button>
                      </div>
                    </div>
                  ) : null}
                </th>

                <th className="table-heads " width={"14%"}>
                  Actions
                </th>
              </tr>
            </thead>
            <tbody style={{ position: "relative" }}>
              {loading === true ? (
                <div className="list-spinner-container">
                  <LoadingSpinnerTable />
                </div>
              ) : distributorListData?.distributors?.length > 0 ? (
                <>
                  {distributorListData?.distributors?.map((eachRow, index) => (
                    <DistributorTableData
                      key={eachRow.id}
                      data={eachRow}
                      index={index}
                      distributorListFunc={distributorListFunc}
                      is_subscribed={is_subscribed}
                    />
                  ))}
                </>
              ) : (
                <>
                  <tr>
                    <td
                      colSpan="1"
                      className="text-center no-data-container fs_16"
                    >
                      <span>~ No Data Found ~</span>
                    </td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </div>
        <div className={loading === true ? `loading-event` : ""}>
          {distributorListData?.pagination?.totalPages > 0 && (
            <NumberPagination
              setCurrentPage={setPage}
              pagination={distributorListData?.pagination?.currentPage}
              totalPages={distributorListData?.pagination?.totalPages}
              path={"/distributors/onboarded"}
              filters={`${queryString}`}
            />
          )}
        </div>
        <LinkDistributorModal
          show={linkShow}
          handleClose={linkClose}
          distributorListFunc={distributorListFunc}
        />
        <ErrorPopup
          show={showErrorPopup}
          title={showErrorMsg}
          handleClose={closeErrorPopup}
        />
      </div>
    </>
  );
};

export default DistributorTable;
